import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import VueAxios from './plugins/axios';

import App from './App.vue';

Vue.use(VueSweetalert2);
Vue.use(VueAxios);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');
